<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive
      code="cessation_ouinon"
      v-model="sasSociete.declarerCessationDActivite"
      :live="liveSociete(25935)"
    />
    <v-alert
      type="error"
      text
      icon="mdi-alert-circle-outline"
      v-if="!conditionCessationActiviteValide && conditionCessation"
    >
      <ressource code="condition_cessation_activites" />
    </v-alert>
    <v-checkbox
      v-show="false"
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="conditionCessationActiviteValide || !conditionCessation"
      :rules="[(v) => !!v || getRessource('condition_cessation_activites')]"
    ></v-checkbox>
    <DatePickerLive
      code="cessation_date_fin"
      v-model="sasCessation.declarerCessationDActivite"
      :live="liveCessationActivite(26802)"
      :opqIf="conditionCessationActiviteValide"
    />
    <FileInput
      code="cessation_justificatif"
      :file="sasCessation.justificatifCessation"
      :live="liveCessationActivite(26803)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opqIf="conditionCessationActiviteValide"
    />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import RessourcesHelpers from "@/components/ui/mixins/RessourcesHelpers"
export default {
  mixins: [CataloguesHelpers, StepFormWithValidation, RessourcesHelpers],
  props: {
    sas: { type: Object },
  },

  computed: {
    sasCessation() {
      return this.sas.sasCessation
    },
    sasSociete() {
      return this.sas.sasSociete
    },
    conditionCessation() {
      return this.estOui(this.sas.sasSociete.declarerCessationDActivite)
    },
    conditionCessationActiviteValide() {
      return (
        this.conditionCessation &&
        this.estNon(
          this.sasSociete.souhaitezVousMettreAJourLesInformationsDeLaSociete
        ) &&
        this.estNon(this.sasSociete.declarerAjoutDActionnaires) &&
        this.estNon(this.sasSociete.declarerLeRetraitDActionnaire) &&
        this.estNon(this.sasSociete.declarerLaModificationDeRepondant) &&
        this.estNon(
          this.sasSociete.declarerLOuvertureDUneOuDePlusieursPharmacies
        ) &&
        this.estNon(this.sasSociete.declarerLaFermetureDUnePharmacie) &&
        this.estNon(
          this.sasSociete.declarerLAchatDUneOuDePlusieursPharmacies
        ) &&
        this.estNon(this.sasSociete.declarerVentePharmacie) &&
        this.estNon(this.sasSociete.declarerDemenagementPharmacie) &&
        this.sas.fermetures.length === 0 &&
        this.sas.demenagements.length === 0 &&
        this.sas.fermetures.length === 0
      )
    },
  },
  methods: {
    liveCessationActivite(cle) {
      return {
        endpoint: "sas-cessation-activite",
        cle: cle,
        fileId: this.sasCessation.id,
      }
    },
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
  },
}
</script>

<style></style>
